import * as yup from "yup"
import { requiredErr } from "src/utils/constants"
import { sqlEditorFieldNames } from "./Constant"

export const validationSchema = () => {
  return yup.object().shape({
    [sqlEditorFieldNames.RawSQL.name]: yup.string().required(requiredErr)
  })
}
